import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const AbstractTextElementContext = /*#__PURE__*/createContext(undefined);
export const AbstractTextElementProvider = ({
  abstractElementStylesOverrides,
  children
}) => {
  const value = useMemo(() => ({
    abstractElementStylesOverrides
  }), [abstractElementStylesOverrides]);
  return /*#__PURE__*/_jsx(AbstractTextElementContext.Provider, {
    value: value,
    children: children
  });
};

/**
 * Provides the context for the `AbstractTextElement` component.
 * Note: The context is only available when the `AbstractTextElement` component is rendered as an ancestor.
 * @returns AbstractTextElementContext - The context for the `AbstractTextElement` component.
 * @returns AbstractTextElementContext.abstractElementStylesOverrides - Style overrides to be applied to the `Popover` component.
 */
export const useAbstractTextElementContext = () => {
  const abstractTextElementContext = useContext(AbstractTextElementContext);
  return abstractTextElementContext;
};